import React, { useEffect, useRef, useState } from 'react'
import PropTypes from 'prop-types'

import Glyph from 'component/utils/Glyph'
import TableArrowDown from 'component/svgComponents/tableArrowDown'
import moment from 'moment'
import { isArray } from 'utils/validations'

const Table = ({
  cdMissionList,
  openModal,
  editModal,
  closeModal,
  records,
  handleOrder,
  setCdMissionList,
  translate,
  removeSelected
}) => {
  const [orders,setOrders] = useState([{id: "name", active: true, reverse: true}, {id:"tsUpdate", active: false, reverse: true}])
  const tableRef = useRef(null)
  const [height,setHeight] = useState(0)
  // Pagination below table
  const PAGINATION_HEIGHT = 71
  // Search and Filter
  const TOP_ACTIONS = 95
  // TOOLBAR + Title
  const TOP_BAR = 67 + 50

  useEffect(() => {
    setHeight(window.innerHeight)
    const calculateHeight = () => {
      setHeight(window.innerHeight)}
    window.addEventListener("resize", calculateHeight)
    return () => window.removeEventListener("resize", calculateHeight)
  }, [])

  const changeOrder = (index, previousIndex) => {
    const newOrders = [...orders]
    
    if(newOrders[index].active) {
      newOrders[index].reverse = !newOrders[index].reverse
    }

    else {
      newOrders[index].active = true
      newOrders[previousIndex].active = false
    }

    setOrders(newOrders)
    const active = newOrders.find(or => or.active)
    const direction = active.reverse ? 'ASC' : 'DESC'
    handleOrder(active.id, direction)
  }


  useEffect(() => {

    if(height < 868 && height !== 0) {
      const responsiveHeight = height - (PAGINATION_HEIGHT + TOP_ACTIONS + TOP_BAR + 100)
      const tbody = document.querySelector('.tbody-mission-block')
      tbody.style.maxHeight = `${responsiveHeight}px`
    }
    else {
      const tbody = document.querySelector('.tbody-mission-block')
      tbody.style.maxHeight = `500px`
    }
  }, [height])
  const renderHeader = () => {

    let checked = false
    let setAll = true
    let checkedClassName = "stock-transfer-checkbox"
    const cdMissionListLength = cdMissionList.length

    if (cdMissionListLength) {
      if (cdMissionListLength < records.length) {
        checked = true
        checkedClassName = "stock-transfer-checked-mid"
      } else {
        checked = true

        setAll = false
      }
    }

    useEffect(() => {

    }, [records])

    return (
      <tr className='pictograms-tr'>
        <th
          onClick={() => {

            setCdMissionList(setAll ? records.map((i) =>  ({id: i.id, name: i.name, pictogramParams: isArray(i.pictograms) ? i.pictograms.filter(p => p.filePath).map(p => ({filePath: p.filePath}))  : [] })) : [])
          }
            
          }
          className='text-align-center'
        >

          <input checked={checked} type={"checkbox"} className={checkedClassName} />

        </th>
        <th style={{cursor: 'pointer', width: cdMissionList.length < 1 &&  "20%", }} onClick={() => changeOrder(0,1)}>Atributos  <TableArrowDown hide={cdMissionList.length > 0} active={orders[0].active} reverse={orders[0].reverse} /></th>
        <th style={{cursor: 'pointer', width: cdMissionList.length < 1 &&  "17%", }} onClick={() => changeOrder(1,0)}>Última atualização <TableArrowDown hide={cdMissionList.length > 0 } active={orders[1].active} reverse={orders[1].reverse}  /></th>
        <th style={{width: cdMissionList.length < 1 &&  "17%"}}>Qtde. de pictogramas</th>
        <th style={{width: cdMissionList.length < 1 &&  "17%"}}>Status do Cadastro</th> 
    
        <th style={{ display: cdMissionListLength > 0 ? 'none' : ''}} className='text-align-center right-side-icons'>Visualizar</th>
        <th style={{ display: cdMissionListLength > 0 ? 'none' : ''}} className='text-align-center right-side-icons'>{translate('edit_button_label')}</th>
        <th style={{ display: cdMissionListLength > 0 ? 'none' : ''}} className='text-align-center right-side-icons'>Excluir</th>
      </tr>
    )
  }

  const renderBody = () => {

    const renderRecord = (record) => {
      const { id } = record
   
      const checked = cdMissionList.some((item) => item.id === id)
     
      return (
        <tr className={`${checked ? 'stock-transfer-checked' : ''}`} key={id}>
          <td style={{width: cdMissionList.length < 1 && '25%'}}
            onClick={() =>
              {
              const pictogramsToDelete = isArray(record.pictograms) ? record.pictograms.filter(p => p.filePath).map(p => ({filePath: p.filePath}))  : []
              
              checked && removeSelected(id)
              setCdMissionList(
                checked
                  ? cdMissionList.filter((i) => i.id !== id)
                  : [...cdMissionList, {id: record.id, name: record.name, pictogramParams: pictogramsToDelete}]
              )
              }
            }
            className='text-align-center'
          >
            <input type={"checkbox"} className="stock-transfer-checkbox" value={checked} checked={checked} />
          </td>
          <td style={{width: cdMissionList.length < 1 && "20%"}}>{record.name}</td>
          <td style={{width: cdMissionList.length < 1 && "17%"}}>{record.tsUpdate ? moment(record.tsUpdate, 'YYYY-MM-DD').format('L') : '-'}</td>
          <td style={{width: cdMissionList.length < 1 && "17%"}}> {record.qtyPictogram}</td>
          
          <td style={{color: record.status === 'Completo' ? '#158110' : '#B42A27', fontWeight:600, width: cdMissionList.length < 1 &&  "17%"}}> {record.status} </td>
        
          <td style={{display: cdMissionList.length > 0 ? 'none' : ''}} className='mission-block-edit-icon'>
            <Glyph
              type='eye'
              color='primary'
              onClick={() => openModal(record)}
            />
          </td>

          <td style={{display: cdMissionList.length > 0 ? 'none' : ''}} className='mission-block-edit-icon'>
            <Glyph
              type='pencil'
              color='primary'
              onClick={() => editModal(record)}
            />
          </td>

          <td style={{display: cdMissionList.length > 0 ? 'none' : ''}} className='mission-block-edit-icon'>
            <i  onClick={() => closeModal({id: record.id, pictogramParams: isArray(record.pictograms) ? record.pictograms.filter(p => p.filePath).map(p => ({filePath: p.filePath}))  : [] })} className='color-danger glyph glyph-trash-can icon-size pictogram-trash-icon' />
          </td>
        </tr>
      )
    }

    return records.map(renderRecord)
  }

  return (
    <table  cellPadding={0} cellSpacing={0} className={`mission-block-table-new new pictograms-table ${cdMissionList.length ? 'pictograms-check-mode' : ''}`}>
      <thead ref={tableRef}>{renderHeader()}</thead>
      <tbody className='tbody-mission-block'  onScroll={(e) => {
        if(e.currentTarget.scrollTop > 20) {
          tableRef.current.classList.add("shadow-table-header-mission-block")
        }
        else {
          tableRef.current.classList.remove("shadow-table-header-mission-block")
        }
      }} >{renderBody()}</tbody>
    </table>
  )
}

Table.propTypes = {
  cdMissionList: PropTypes.array.isRequired,
  editModal: PropTypes.func.isRequired,
  closeModal: PropTypes.func.isRequired,
  handleResize: PropTypes.func.isRequired,
  openModal: PropTypes.func.isRequired,
  records: PropTypes.array.isRequired,
  setCdMissionList: PropTypes.func.isRequired,
  size: PropTypes.number.isRequired,
  translate: PropTypes.func.isRequired,
  removeSelected: PropTypes.func.isRequired,
  handleOrder: PropTypes.func.isRequired
}

export default Table
